import React from 'react';
import PropTypes from 'prop-types';

import ActionComponent from '../Component/Action';
import { useAttachsParams } from 'providers/attachs-params';

const ActionBase = (props) => {
    const { tooltipComponentId } = useAttachsParams();
    const dataFor = props.toolTipSelector || tooltipComponentId;

    return (
        <ActionComponent data-for={dataFor} {...props} />
    );
};

ActionBase.propTypes = { toolTipSelector: PropTypes.string };

export default ActionBase;
